<template>
	<base-form class="login-form">
		<template #header>
			<h2 class="login-form__title">Log in</h2>

			<p class="login-form__description">
				Welcome to
				<br />
				the I'am app.
			</p>
		</template>

		<form-element v-bind="{ errors, model, loading }" @submit="onSubmit">
			<form-item label="E-mail" :name="'email'" :rules="[required, email]">
				<input
					v-model="model.email"
					class="login-form__input"
					name="email"
					type="email"
					autocomplete="login-email"
				/>
			</form-item>

			<form-item label="Password" name="password" :rules="[required]">
				<input
					v-model="model.password"
					class="login-form__input"
					name="password"
					type="password"
					autocomplete="current-password"
				/>
			</form-item>

			<template #buttons>
				<router-link :to="{ name: 'forgot-password' }" class="login-form__forgot-password">
					Forgot your password?
				</router-link>

				<base-button secondary type="submit" v-bind="{ loading }">Login</base-button>
			</template>
		</form-element>
		<div class="login-form-contact">
			<p class="login-form-contact__description">
				If you have any questions,
				<br />
				please contact us:
				<br />

				hello@glazeprosthetics.com
			</p>
		</div>
	</base-form>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import FormElement from '@/components/form/FormElement.vue';
import FormItem from '@/components/form/FormItem.vue';
import { ApiErrors } from '@/store/types';
import { email, required } from '@/tools/validation';

export default defineComponent({
	components: {
		FormElement,
		FormItem,
	},

	props: {
		loading: {
			type: Boolean,
			default: false,
		},

		errors: {
			type: Object as PropType<ApiErrors>,
			default: () => ({}),
		},
	},

	emits: ['submit'],

	data() {
		return {
			model: {
				email: '',
				password: '',
			},
		};
	},

	methods: {
		email,
		required,

		onSubmit() {
			const data = new FormData();

			data.append('email', this.model.email);
			data.append('password', this.model.password);

			this.$emit('submit', data);
		},
	},
});
</script>

<style lang="scss">
.login-form-contact {
	margin-top: 2rem;

	&__email {
		margin: 0;
		padding: 0;
		color: $color-light !important;
	}
}

.login-form {
	color: $color-light;

	&__title {
		margin-bottom: 0.5rem;
		font-size: $font-size-body;
	}

	&__description {
		font-size: 4.8rem;
		font-weight: 500;
		line-height: 1.22;
		letter-spacing: 0.025em;

		@include max-lg-and-portrait {
			font-size: 3.2rem;
		}
	}

	.form-item {
		margin-bottom: 4rem;

		@include max-lg-and-portrait {
			margin-bottom: 3.5rem;
		}

		label {
			color: inherit;
		}

		input {
			&,
			&:focus,
			&:-webkit-autofill,
			&:-webkit-autofill:active,
			&:-webkit-autofill:hover,
			&:-webkit-autofill:focus {
				color: $color-dark !important;
				font-size: $font-size-input;
				background-color: $color-light !important;
			}
		}

		&__error {
			margin-top: 1rem;
		}
	}

	.form-element__buttons {
		margin-top: 4rem;

		@include max-lg-and-portrait {
			margin-top: 4.5rem;
		}
	}
}
</style>
